import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    eventName: String,
    location: String,
    path: String
  }

  connect() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    fetch('/note/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify({ event_name: this.eventNameValue, location: this.locationValue, path: this.pathValue })
    })
  }
}
